document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pet-discover').forEach((section, index) => {
    const listEl = section.querySelector('.pet-discover__list');
    const $list = $(listEl);
    if (!$list.length) return;

    // Keep in sync with CSS:
    // ≥1001 pc (slider only if cards > pcSlides)
    // ≤1000 column + card slider (pad / mb slides)
    const mqPadDown = window.matchMedia('(max-width: 1000px)');
    const pcSlides = Math.max(1, parseInt(listEl.getAttribute('data-pc-slidestoshow'), 10) || 3);
    const padSlides = Math.max(1, parseInt(listEl.getAttribute('data-pad-slidestoshow'), 10) || 2);
    const mbSlides = Math.max(1, parseInt(listEl.getAttribute('data-mb-slidestoshow'), 10) || 1);
    const pcArrows = listEl.getAttribute('data-pc-arrows') === 'true';
    const padArrows = listEl.getAttribute('data-pad-arrows') === 'true';
    const mbArrows = listEl.getAttribute('data-mb-arrows') === 'true';
    const pcDots = listEl.getAttribute('data-pc-dots') !== 'false';
    const padDots = listEl.getAttribute('data-pad-dots') !== 'false';
    const mbDots = listEl.getAttribute('data-mb-dots') !== 'false';
    const slideCount = listEl.querySelectorAll('.pet-discover__item').length;

    const shouldSlider = () => mqPadDown.matches || slideCount > pcSlides;

    const destroySlider = () => {
      if ($list.hasClass('slick-initialized')) {
        $list.slick('unslick');
      }
    };

    const initSlider = () => {
      if ($list.hasClass('slick-initialized')) return;

      // Slick applies responsive when width < breakpoint (not ≤),
      // so use 1001 / 750 to match CSS max-width: 1000 / 749.
      $list.slick({
        infinite: true,
        draggable: true,
        slidesToShow: pcSlides,
        slidesToScroll: 1,
        autoplay: false,
        arrows: pcArrows,
        prevArrow: `<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="pet-discover-prev-${index}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="pet-discover-prev-${index}">Prev Item</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>`,
        nextArrow: `<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="pet-discover-next-${index}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="pet-discover-next-${index}">Next Item</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>`,
        dots: pcDots,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1001,
            settings: {
              slidesToShow: padSlides,
              slidesToScroll: 1,
              arrows: padArrows,
              dots: padDots,
            },
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: mbSlides,
              slidesToScroll: 1,
              arrows: mbArrows,
              dots: mbDots,
            },
          },
        ],
      });
    };

    const syncSlider = () => {
      if (shouldSlider()) {
        initSlider();
      } else {
        destroySlider();
      }
    };

    syncSlider();

    if (typeof mqPadDown.addEventListener === 'function') {
      mqPadDown.addEventListener('change', syncSlider);
    } else if (typeof mqPadDown.addListener === 'function') {
      mqPadDown.addListener(syncSlider);
    }
  });
});
